import { CompanyId } from '@/lib/portal';

export type TechBranding = {
  companyId: CompanyId;
  displayName: string;
  logoPath: string;
  primaryColor: string;
  secondaryColor: string;
};

export function getTechBranding(companyId: CompanyId | null): TechBranding {
  if (companyId === 'hales-ac') {
    return {
      companyId,
      displayName: 'Hales AC',
      logoPath: '/brands/hales-logo.png',
      // Matches production public-config today (tech.halesac.com)
      primaryColor: '#2563EB',
      secondaryColor: '#4F46E5',
    };
  }

  if (companyId === 'abraham-ac') {
    return {
      companyId,
      displayName: 'Abraham AC',
      logoPath: '/brands/abraham-logo.png',
      // Matches production public-config today (tech.abrahamac.com)
      primaryColor: '#22C55E',
      secondaryColor: '#16A34A',
    };
  }

  // Default: Climate Control Services (tech.my-ccs.com)
  return {
    companyId: 'climate',
    displayName: 'Climate Control Services',
    logoPath: '/brands/climate-logo.png',
    // Matches production public-config today (tech.my-ccs.com)
    primaryColor: '#0EA5E9',
    secondaryColor: '#6366F1',
  };
}

export function applyTechBrandingCssVariables(branding: TechBranding | null) {
  if (typeof document === 'undefined') return;

  const primary = branding?.primaryColor || '#2563EB';
  const secondary = branding?.secondaryColor || '#4F46E5';

  document.documentElement.style.setProperty('--brand-primary', primary);
  document.documentElement.style.setProperty('--brand-secondary', secondary);
}
